export class FieldOption {
  constructor({
    id = 0,
    componentName = "",
    ref = "",
    option = 0,
    rule = "",
  } = {}) {
    this.id = id;
    this.componentName = componentName;
    this.ref = ref;
    this.option = option;
    this.rule = rule;
  }
}

export function createNewFieldOption(data) {
  return Object.freeze(new FieldOption(data));
}
